import _get from 'lodash/get';
import { wampCall } from 'utils/initUtils';
import Logger from 'js-logger';
import { DirectoryHit } from '../interfaces/directory';

const searchDirectory = async (entity: string, searchQuery: string): Promise<[]> => {
  const funcCall = {
    uriSuffix: `directory/search/${entity}?searchString=${searchQuery}`,
    httpMethod: 'GET',
    inputParams: null,
    queryParams: null
  };
  try {
    const results = await wampCall({ procedure: 'lifesize.directory', args: [JSON.stringify(funcCall)] });
    const parsedResults = JSON.parse(results);
    return _get(parsedResults, 'hits.hits', []);
  } catch (e) {
    Logger.debug(e);
    return [];
  }
};

const getDirectoryResults = async (type: string, searchQuery: string) => {
  const hits = await searchDirectory(type, searchQuery);
  return hits.map((meeting: DirectoryHit) => {
    return {
      UUID: meeting._source.UUID,
      displayName: meeting._source.displayName,
      extension: meeting._source.extension
    };
  });
};

export const searchMeetings = async (searchQuery: string) => {
  return await getDirectoryResults('meeting', searchQuery);
};

export const searchRoomSystems = async (searchQuery: string) => {
  return await getDirectoryResults('room', searchQuery);
};
